module.exports = __webpack_public_path__ + "img/電気回路_3_4.9544bc29.png";